import { render, staticRenderFns } from "./AuthorizeFarm.vue?vue&type=template&id=ba2d4b96&"
import script from "./AuthorizeFarm.vue?vue&type=script&lang=ts&"
export * from "./AuthorizeFarm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports